import Modal from 'components/Modals/Modal';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helpers } from 'utils/Helpers-v1';
import { v4 as uuidv4 } from 'uuid';

function WebviewPing(props) {
  const { backButtonPressed, addModal, popModal } = props;
  const navigate = useNavigate();
  //const {isWebView, setIsWebView} = useContext(MainContext);

  const onMessageFromWebView = (payload) => {
    if (payload.data.source === 'react-devtools-content-script') return null;
    if (payload.data.source === 'react-devtools-bridge') return null;

    try {
      if (payload.data == null || payload.data === '') return;
      let data = payload.data;
      try {
        data = JSON.parse(payload.data);
      } catch (e) {
        data = payload.data;
      }
      switch (data.action) {
        case 'ping': {
          Helpers.sendMessageToWebView(JSON.stringify({ action: 'pong' }));
          break;
        }
        case 'backPressed': {
          let res = backButtonPressed();
          if (res === true) openModal();
          break;
        }
        case 'setUUIDs': {
          localStorage['playerId'] = data.data.playerId;
          localStorage['deviceUUID'] = data.data.deviceUUID;
          break;
        }
        case 'readQRCodeResult': {
          let index = data.data.code.lastIndexOf('/');
          let shortID = data.data.code.slice(index + 1, data.data.code.length);
          navigate(`/c/t/${shortID}`);
          break;
        }
        case 'isWebView': {
          //setIsWebView(true);
          break;
        }
        default: {
          break;
        }
      }
    } catch (e) {
      console.log('onMessageFromWebView', e);
    }
  };

  const openModal = () => {
    if (!/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent)) {
      addModal(
        <Modal key={uuidv4()} addClass='exitModal' onClickLayout={popModal}>
          <div className='modal-header-img-container exit-modal-header-img-container'></div>
          <div className='modal-content-container exit-modal-content-container'>
            <div className='modal-text'>{/*getValue('app_v2_exit_modal_text')*/}Ezzel a művelettel bezárod az alkalmazást!</div>
            <div className='modal-text2'>{/*getValue('app_v2_exit_modal_text2')*/}Folytatod?</div>
            <div className='modal-btn-container'>
              <div className='btn primary' onClick={exitApp}>
                {/*getValue('app_v2_exit_yes')*/ 'Igen'}
              </div>
              <div className='btn secondary' onClick={popModal}>
                {/*getValue('app_v2_exit_cancel')*/ 'Nem'}
              </div>
            </div>
          </div>
        </Modal>
      );
    }
  };

  const exitApp = () => Helpers.sendMessageToWebView(JSON.stringify({ action: 'exitApp' }));

  useEffect(() => {
    document.addEventListener('message', onMessageFromWebView);
    window.addEventListener('message', onMessageFromWebView);

    Helpers.sendMessageToWebView(JSON.stringify({ action: 'pong' }));
    Helpers.sendMessageToWebView(JSON.stringify({ action: 'appLoaded' }));
    Helpers.sendMessageToWebView(JSON.stringify({ action: 'getUUIDs' }));

    // eslint-disable-next-line
  }, []);

  return null;
}

export default WebviewPing;
